<template>
	<v-sheet class="pa-12" rounded>
		<v-card class="mx-auto px-6 py-8" maxWidth="344">
			<h1>Login</h1>
			<v-form @submit="onSubmit">
				<v-text-field v-model="username" type="text" label="Username" />
				<br />
				<v-text-field v-model="password" type="password" label="Password" />
				<br />
				<v-btn type="submit">Login</v-btn>
				<v-btn @click="$router.push('/register')">Register</v-btn>
			</v-form>
		</v-card>
	</v-sheet>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";

export default {
	data: () => {
		return {
			username: "",
			password: "",
		};
	},
	methods: {
		...mapMutations(["setUser", "setToken"]),
		onSubmit(event) {
			event.preventDefault();
			if (!this.username || !this.password) {
				alert("Please insert data");
				return;
			}
			axios
				.post(process.env.VUE_APP_BACKEND_URL + "/auth/login", {
					email: this.username,
					password: this.password,
				})
				.then((response) => {
					const user = response.data.user;
					const token = response.data.token;

					this.setUser(user);
					this.setToken(token);
					this.$router.push("/");
				})
				.catch((e) => {
					console.log(e);
				});

			this.password = "";
			this.username = "";
		},
	},
};
</script>

<style scoped>
.loginpage {
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
.loginform {
	background: #f2f2f2;
	border-radius: 12px;
	padding: 30px;
	box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
	text-align: center;
}
</style>
